import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { useSelector } from 'dva';
import {
  TextFieldCom,
  SelectFieldCom,
  CascadeFieldCom,
  DatePickerCom,
} from '../../../components/FormType';
import webStorage from '@/utils/storageManager';
import { Controller } from 'react-hook-form';
import DateRangePickerML from '@/components/DateRangePickerML/DateRangePickerML';
import {
  ISHAVEAVALUE,
  NOHAVEAVALUE,
  ISRELATIVE,
  ISABSOLUTE,
  ISBEFORE,
  ISAFTER,
  checkTypeStatusThree,
  checkTypeStatusTwo,
  checkTypeStatus,
  getDicListTwo,
  getDicList,
} from '../.././constants';
import LabelRulesStyled from './LabelRulesStyled';

// 校验
const checkForm = (data, errors) => {
  let status = false;
  data &&
    data.forEach((item) => {
      for (let it in item) {
        if (errors && errors[`${it}-${item.id}`]) {
          status = true;
          break;
        }
      }
    });
  return status;
};

const checkFileShow = (value) => {
  if (value) {
    const conditionTypeCode = value[0].conditionTypeCode;
    if (conditionTypeCode === 'DIMENSION_TABLE') {
      return false;
    }
    return true;
  }
  return true;
};

const checkDateStatus = (value) => {
  return value;
};

export default ({
  queryType, //编辑 详情
  control,
  errors,
  setValue,
  getValues,
  setError,
  clearErrors,
  tagRule = null, //标签规则数据
  setFieldValueP,
}) => {
  const { tagBehaviorConditionListDate, queryTagOperatorValue } = useSelector(
    (state) => state.statisticsCreateLabel,
  );

  // 获取字段列表数据
  const [ruleList, setRuleList] = useState([]);

  const [number, setNumber] = useState(0);
  // 字典项
  const dicObj = webStorage.get('DICTOBJ') || {};

  useEffect(() => {
    tagRule.forEach((item) => {
      setValue(`valueFieldIds-${item.id}`, item.valueFieldIds);
      setValue(`operation-${item.id}`, item.operation);
      setValue(`operationValue-${item.id}`, item.operationValue);
      setValue(`operationAnd-${item.id}`, item.operationAnd);
      setValue(`operationAndValue-${item.id}`, item.operationAndValue);
      setValue(`operationType-${item.id}`, item.operationType);
      setValue(`behaviorType-${item.id}`, item.behaviorType);
      setValue(`behaviorId-${item.id}`, item.behaviorId);
    });
  }, [tagRule, setValue, number]);

  const setFieldValue = (data) => {
    const { self, value, realName, info } = data; //self =1 点击的第一个级联，self = 2点击的非时间的选择和时间的第二个条件选择，self=3点击的时间的第一个条件
    setFieldValueP(data);
    const today = new Date();
    const date =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();
    if (self === 1) {
      //重置后面所有的值
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationType',
      });
    } else if (self === 2) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 3) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
    } else if (self === 4) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 5) {
      let v = null;
      if (info?.operationType === 3) {
        if (value === 7 || value === 8) {
          v = { startDate: null, endDate: null };
        } else if (
          info &&
          info.operationValue &&
          typeof info.operationValue !== 'object'
        ) {
          v = info.operationValue;
        } else {
          v = date;
        }
      }
      setFieldValueP({
        ...data,
        value: v,
        realName: 'operationValue',
      });
    }
    (realName !== 'operationValue' ||
      (realName === 'operationValue' &&
        info?.operation !== 7 &&
        info?.operation !== 8)) &&
      setNumber(number + 1);
  };

  // 处理级联结构
  const handleOptions = (options) => {
    return (options || []).map((item) => {
      // eslint-disable-next-line no-unused-vars
      const { children, ...i } = item;
      return item.conditionTypeCode !== 'DIMENSION_TABLE' ? item : i;
    });
  };

  useEffect(() => {
    const newOptions = handleOptions(tagBehaviorConditionListDate);
    setRuleList(newOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagBehaviorConditionListDate]);
  //获取接口返回的选择项
  const getFetchList = (value, data) => {
    let list = [];
    if (value && Array.isArray(value) && value.length > 0 && data) {
      const typeThree = value[value.length - 1].fileCodeEnumGroupType;
      data.forEach((item) => {
        if (item.labelGroup === typeThree) {
          list = item.valueAndLabelList;
          return;
        }
      });
    }
    return list;
  };
  // 数值、文本、日期类标签
  const mathLabel = () => {
    return (
      <Box className="math_label">
        {checkForm(tagRule, errors) && (
          <Box className="title">
            <span style={{ color: '#f44336', fontSize: '.75rem' }}>
              此项有未完成输入或选择项
            </span>
          </Box>
        )}
        {tagRule &&
          Array.isArray(tagRule) &&
          tagRule.length > 0 &&
          tagRule.map((item, ind) => {
            return (
              <Box
                key={ind}
                sx={{
                  display: 'flex',
                  gap: '0 32px',
                  alignItems: 'flex-end',
                }}
              >
                <Box sx={{ width: '200px' }}>
                  <CascadeFieldCom
                    label="请选择属性/行为"
                    showLabel={false} //是否需要显示label
                    showError={false} //false输入框捕获到错误不展示错误样式，默认true
                    cascadeData={ruleList}
                    queryType={queryType}
                    setValue={setValue}
                    control={control}
                    name={'valueFieldIds-' + item.id}
                    realName="valueFieldIds"
                    fieldNames={{ label: 'fileName', value: 'id' }}
                    nameMessage="标签是必选项"
                    errors={errors}
                    setError={setError}
                    clearErrors={clearErrors}
                    setFieldValue={setFieldValue}
                    isShowSearch={true} //开启搜索
                    parameter={{
                      selfId: item.id,
                      self: 1,
                    }}
                    rules={{
                      required: true, //是否是必填项true 必填 false 非必填
                      validate: (value) => value?.length > 0,
                    }}
                  />
                </Box>
                {checkTypeStatus(item.valueFieldIds) &&
                  !checkTypeStatusTwo(item.valueFieldIds) &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件"
                        placeholder="请选择条件"
                        initLabel=""
                        name={'operation-' + item.id}
                        realName="operation"
                        queryType={queryType}
                        setValue={setValue}
                        getValues={getValues}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage=""
                        // setBehaviorId={setBehaviorId}
                        typeList={getDicList(item.valueFieldIds, dicObj)}
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 2,
                        }}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {/*时间的第一个选择*/}
                {checkTypeStatus(item.valueFieldIds) &&
                  checkTypeStatusTwo(item.valueFieldIds) &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件"
                        initLabel=""
                        placeholder="请选择条件"
                        name={'operationType-' + item.id}
                        realName="operationType"
                        queryType={queryType}
                        setValue={setValue}
                        getValues={getValues}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage=""
                        typeList={getDicList(item.valueFieldIds, dicObj)}
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 3,
                        }}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {/*第二个输入框 非时间输入框*/}
                {!checkTypeStatusTwo(item.valueFieldIds) &&
                  checkTypeStatusThree(item.valueFieldIds) !== 8 &&
                  checkTypeStatus(item.valueFieldIds) &&
                  item.operation !== ISHAVEAVALUE &&
                  item.operation !== NOHAVEAVALUE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box
                      display="flex"
                      alignItems="flex-end"
                      position="relative"
                      bottom="-4px"
                      width="118"
                    >
                      <TextFieldCom
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        placeholder="请输入"
                        queryType={queryType} //detail不可编辑用于详情
                        helperText="" //用于校验的提醒文字
                        name={`operationValue-${item.id}`}
                        label="" //label
                        control={control}
                        errors={errors}
                        // endAdornment="天"
                        setValue={setValue}
                        isTextLimt={false} //限制输入- . ,首位不以0开头
                        isNumber={false}
                        isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                        isParseInt={false} //true 只能输入正整数，false可以输入小数
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true
                        realName="operationValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                        rules={{
                          required: true,
                        }}
                        initHeight={{ height: 'auto' }}
                      />
                    </Box>
                  )}
                {!checkTypeStatusTwo(item.valueFieldIds) &&
                  checkTypeStatusThree(item.valueFieldIds) === 8 &&
                  checkTypeStatus(item.valueFieldIds) &&
                  item.operation !== ISHAVEAVALUE &&
                  item.operation !== NOHAVEAVALUE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box width="109px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件"
                        initLabel=""
                        placeholder="请选择"
                        name={'operationValue-' + item.id}
                        realName="operationValue"
                        queryType={queryType}
                        setValue={setValue}
                        getValues={getValues}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage=""
                        // defaultValue={it?.operationType}
                        typeList={getFetchList(
                          item.valueFieldIds,
                          queryTagOperatorValue,
                        )}
                        setFieldValue={setFieldValue}
                        parameter={{
                          wid: item.id,
                          selfId: item.id,
                        }}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'labelCode',
                        }}
                        rules={{
                          required: true, //是否是必填项true 必填 false 非必填
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType &&
                  item.operationType !== ISHAVEAVALUE &&
                  item.operationType !== NOHAVEAVALUE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="日期的第二个条件"
                        placeholder="请选择条件"
                        initLabel=""
                        name={'operation-' + item.id}
                        queryType={queryType}
                        setValue={setValue}
                        getValues={getValues}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage="日期的第二个条件"
                        typeList={getDicListTwo(
                          item,
                          dicObj,
                          'conditionTwoGroupType',
                        )}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        realName="operation"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 5,
                          info: item,
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISRELATIVE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) &&
                  checkDateStatus(getValues('operation-' + item.id)) &&
                  ![7, 8].includes(
                    checkDateStatus(getValues('operation-' + item.id)),
                  ) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <DatePickerCom
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true  绝对时间
                        name={'operationValue-' + item.id}
                        showLabel={false}
                        rules={{
                          required: true,
                        }}
                        label=""
                        defaultValue={item.operationValue ?? new Date()}
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        realName="operationValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          info: item,
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISRELATIVE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) &&
                  checkDateStatus(getValues('operation-' + item.id)) &&
                  [7, 8].includes(
                    checkDateStatus(getValues('operation-' + item.id)),
                  ) && (
                    <Box
                      width="260px"
                      display="flex"
                      alignItems="flex-end"
                      sx={{ position: 'relative', bottom: '-15px' }}
                    >
                      <Controller
                        name={'operationValue-' + item.id}
                        control={control}
                        rules={{
                          validate: () => {
                            const status =
                              getValues('operationValue-' + item.id) &&
                              getValues('operationValue-' + item.id)
                                .startDate !== null &&
                              getValues('operationValue-' + item.id).endDate !==
                                null;
                            return status;
                          },
                        }}
                        as={(rp) => {
                          return (
                            <DateRangePickerML
                              label=""
                              startText=""
                              endText=""
                              defaultStartDate={
                                item.operationValue?.startDate || null
                              }
                              defaultEndDate={
                                item.operationValue?.endDate || null
                              }
                              rp={rp}
                              setValue={setValue}
                              onChange={(value) => {
                                const { startDate, endDate } = value;
                                startDate &&
                                  endDate &&
                                  setFieldValue({
                                    selfId: item.id,
                                    value: { startDate, endDate },
                                    realName: 'operationValue',
                                    info: item,
                                  });
                                setValue('operationValue-' + item.id, {
                                  startDate,
                                  endDate,
                                });
                              }}
                              handleClearStartDateCall={(value) => {
                                setFieldValue({
                                  selfId: item.id,
                                  value,
                                  realName: 'operationValue',
                                });
                                setValue('operationValue-' + item.id, value);
                              }}
                            />
                          );
                        }}
                      />
                    </Box>
                  )}
                {/*相对时间的第一个输入框*/}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISABSOLUTE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box
                      width="118px"
                      display="flex"
                      alignItems="flex-end"
                      position="relative"
                      bottom={queryType !== 'detail' ? '-4px' : 0}
                    >
                      <TextFieldCom
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        placeholder="请输入"
                        queryType={queryType} //detail不可编辑用于详情
                        helperText="" //用于校验的提醒文字
                        name={`operationValue-${item.id}`}
                        label="条件2数值" //label
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        isNumber={true}
                        isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                        isParseInt={true} //true 只能输入正整数，false可以输入小数
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true
                        rules={{
                          required: true,
                        }}
                        initHeight={{ height: 'auto' }}
                        realName="operationValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                      />
                      <div
                        style={{
                          paddingBottom: '3px',
                          marginLeft: '3px',
                          color:
                            queryType === 'detail'
                              ? 'rgba(0, 0, 0, 0.38)'
                              : '##1565c0',
                        }}
                      >
                        天
                      </div>
                    </Box>
                  )}
                {/*相对时间的条件3*/}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISABSOLUTE &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件3"
                        placeholder="请选择条件"
                        initLabel=""
                        name={'operationAnd-' + item.id}
                        queryType={queryType}
                        setValue={setValue}
                        getValues={getValues}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage="条件2必选项"
                        typeList={getDicListTwo(
                          item,
                          dicObj,
                          'conditionThreeGroupType',
                        )}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        realName="operationAnd"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 4,
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISABSOLUTE &&
                  item.operationAnd &&
                  item.operationAnd !== ISBEFORE &&
                  item.operationAnd !== ISAFTER &&
                  checkFileShow(getValues('valueFieldIds-' + item.id)) && (
                    <Box
                      width="118px"
                      display="flex"
                      alignItems="flex-end"
                      position="relative"
                      bottom="-4px"
                    >
                      <TextFieldCom
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        placeholder="请输入"
                        queryType={queryType} //detail不可编辑用于详情
                        helperText="" //用于校验的提醒文字
                        name={`operationAndValue-${item.id}`}
                        label="条件4数值" //label
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        isNumber={true}
                        isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                        isParseInt={true} //true 只能输入正整数，false可以输入小数
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true
                        rules={{
                          required: true,
                        }}
                        initHeight={{ height: 'auto' }}
                        realName="operationAndValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                      />
                      <div
                        style={{
                          paddingBottom: '3px',
                          marginLeft: '3px',
                          color:
                            queryType === 'detail'
                              ? 'rgba(0, 0, 0, 0.38)'
                              : '##1565c0',
                        }}
                      >
                        天
                      </div>
                    </Box>
                  )}
              </Box>
            );
          })}
      </Box>
    );
  };

  return (
    <LabelRulesStyled
      queryType={queryType}
      color={queryType === 'detail' ? 'rgba(0, 0, 0, 0.38)' : '##1565c0'}
    >
      <Box>{mathLabel()}</Box>
    </LabelRulesStyled>
  );
};
